module.exports = __webpack_public_path__ + "img/couples-016.26735c12.jpg";